import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form, Input, Modal } from 'antd';

const FormItem = Form.Item;
class IndexModal extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  componentDidMount() {}

  submit = () => {
    const { data, isAddType, databaseUuid, database } = this.props;
    this.props.form.validateFields((err, values) => {
      if (!err) {
        const params = {};
        if (isAddType) {
          params.parentUuid = null;
          data && data.uuid && (params.parentUuid = data.uuid);
        } else {
          params.uuid = data.uuid;
          params.parentUuid = data.parentUuid;
        }
        params.name = values.name;
        params.database = database;
        params.databaseUuid = databaseUuid;
        this.props.onOk(params);
        this.props.form.resetFields();
      }
    });
  };

  onCancel = () => {
    this.props.form.resetFields();
    this.props.onCancel();
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const { data, isAddType } = this.props;
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 14 },
    };
    return (
      <Modal
        title={isAddType ? '创建资料目录' : '编辑资料目录'}
        visible={this.props.visible}
        onOk={this.submit}
        onCancel={this.onCancel}
      >
        <Form>
          <FormItem label="资料目录名称" {...formItemLayout}>
            {getFieldDecorator('name', {
              rules: [{ required: true, message: '请填写资料目录名称' }],
              initialValue: isAddType ? null : data.name,
            })(<Input />)}
          </FormItem>
        </Form>
      </Modal>
    );
  }
}

export default connect(state => ({
  accountInfo: state.account_info,
}))(Form.create()(IndexModal));



// WEBPACK FOOTER //
// ./src/components/administrative/material/ModalDirAdd.js